import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import type { Row } from "../../config/types";
import StyledSelect from "./StyledSelect";

export default function EmployeeParticipants({ employees, value, onChange }: {
  employees: Row[];
  value: string[];
  onChange: (value: string[]) => void;
}) {
  const { t } = useTranslation();
  const options = employees.filter(employee => !value.includes(employee.id))
    .map(employee => ({ value: employee.id, label: String(employee.fullName) }));
  return <fieldset className="participant-selector span-two">
    <legend>{t("Participants")}</legend>
    <p>{t("Selected employees will receive an invitation by email.")}</p>
    <StyledSelect
      label={t("Add a participant")}
      value=""
      options={options}
      searchable
      searchPlaceholder={t("Search employees")}
      emptyMessage={t("No employees found.")}
      placeholder={t(options.length ? "Select an employee" : "No employees available")}
      disabled={!options.length}
      onChange={id => { if (!value.includes(id)) onChange([...value, id]); }}
    />
    <ul className="participant-chips" aria-label={t("Selected participants")}>
      {value.map(id => {
        const name = String(employees.find(employee => employee.id === id)?.fullName || t("Unavailable employee"));
        return <li key={id} className="participant-chip">
          <span>{name}</span>
          <button type="button" aria-label={t("Remove {{name}}", { name })} onClick={() => onChange(value.filter(selected => selected !== id))}><X size={14} /></button>
        </li>;
      })}
    </ul>
    <small>{t("{{count}} selected", { count: value.length })}</small>
  </fieldset>;
}
